/**
 * Represents the authenticated application user.
 * Contains user profile, organization, and permission information.
 */
export class AppUser {
    /** User account ID */
    id!: number;
    /** User's full name */
    name!: string;
    /** Map of permission codes to boolean flags */
    roles!: Record<string, boolean>;
    /** User's job title */
    title!: string;
    /** User ID (username) */
    userid!: string;
    /** Currently selected organization ID */
    organizationId!: number;
    /** Hospital code identifier */
    hospitalCode!: number;
    /** URL to user's profile picture */
    userPicture?: string;
    /** @deprecated Use UserProfile.impersonation.originalUserEmail instead */
    impersonator?: string | undefined;
    /** @deprecated Use UserProfile.impersonation.originalUserName instead */
    impersonatorName?: string | undefined;
    /** User's preferred locale */
    locale?: string;
    /** User's email address */
    email!: string;
    /** User's login identifier */
    login!: string;
    /** Whether user is a LOGEX internal employee */
    internal!: boolean;

    /**
     * Checks if user has a specific permission.
     *
     * @param role - Permission code to check
     * @returns True if user has the permission
     */
    public hasPermission(role: string): boolean {
        return this.roles?.[role] || false;
    }
}
